var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pagination", attrs: { "aria-label": "Page navigation" } },
    [
      _c(
        "ul",
        { staticClass: "pagination-list" },
        [
          _c(
            "li",
            { staticClass: "page-item", class: { disabled: _vm.value === 1 } },
            [
              _c(
                "a",
                {
                  staticClass: "page-link",
                  attrs: { "aria-label": "Previous" },
                  on: { click: _vm.backClick },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v(_vm._s(_vm.translations.terms.previousPage)),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.visiblePages, function (item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "page-item",
                class: { active: item === _vm.value },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "page-link",
                    on: {
                      click: function ($event) {
                        return _vm.goToPage(item)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item))]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: _vm.value === _vm.maxPages },
            },
            [
              _c(
                "a",
                {
                  staticClass: "page-link",
                  attrs: { "aria-label": "Next" },
                  on: { click: _vm.forwardClick },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v(_vm._s(_vm.translations.terms.nextPage)),
                  ]),
                ]
              ),
            ]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }